export const faqs = [
  {
    q: 'Cosa posso aspettarmi dalla prima seduta?',
    a: 'Il primo incontro è dedicato a comprendere la tua situazione attuale e i tuoi obiettivi. In un ambiente sicuro e confidenziale, esploreremo insieme le sfide che stai affrontando e svilupperemo un piano terapeutico personalizzato basato sulla Terapia Cognitivo Comportamentale (CBT). Il mio approccio integra una profonda comprensione del legame mente-corpo per un benessere completo.',
  },
  {
    q: 'Quanto dura il percorso terapeutico?',
    a: 'La durata varia in base alle esigenze individuali, con una media di 12-18 mesi. I primi miglioramenti significativi sono spesso visibili fra i primi 3-6 mesi di terapia. Lavoriamo con obiettivi chiari e trasparenti, monitorando costantemente i progressi attraverso metodi scientificamente validati.',
  },
  {
    q: 'Cosa rende unico il tuo approccio terapeutico?',
    a: 'Il mio approccio combina la CBT, scientificamente validata, con l\'innovativo metodo RFD (Relational Fractal Dimension), che permette di monitorare oggettivamente i progressi della terapia. Questa integrazione offre un percorso terapeutico strutturato ma flessibile, adattato alle tue specifiche esigenze.',
  },
  {
    q: 'Quali problematiche tratti principalmente?',
    a: `Mi occupo principalmente di:
- Ansia e attacchi di panico
- Depressione
- Stress e burnout professionale
- Difficoltà relazionali
- Problemi legati all'autostima
- Gestione delle emozioni`,
  },
  {
    q: 'Quali sono i costi delle sedute?',
    a: `- Terapia individuale: €98 per seduta (50 minuti)
- Terapia di coppia: €148 per seduta (50 minuti)

Le sedute sono disponibili sia in presenza che online.`,
  },
  {
    q: 'Come posso prenotare una seduta?',
    a: `Puoi contattarmi attraverso:

- Il form di prenotazione sul sito
- Email: jacopo.biraschi@gmail.com
- Telefono (whatsapp, sms): 3342006649

Rispondo generalmente entro 24 ore lavorative.`,
  },
  {
    q: 'Offri sedute online?',
    a: 'Sì, circa un terzo delle mie sedute si svolge online. L\'efficacia della terapia online è equivalente a quella in presenza, offrendo maggiore flessibilità per chi ha impegni lavorativi o difficoltà negli spostamenti.',
  },
  {
    q: 'Qual è la politica di cancellazione?',
    a: 'È richiesto un preavviso di 24 ore per cancellare o riprogrammare una seduta.',
  },
  {
    q: 'Come viene garantita la privacy?',
    a: 'Tutte le informazioni condivise durante le sedute sono strettamente confidenziali e protette dal segreto professionale. I dati sono gestiti in conformità con il GDPR e le normative sulla privacy vigenti.',
  },
];
